<h2 mat-dialog-title>
  <mat-icon aria-hidden="false" aria-label="Terminal status">adjust</mat-icon>
  Terminalstatus
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  <div class="chip-wrapper">
    <div class="chip-list">
      @for (status of allStatuses; track status) {
        <span
          class="chip"
          [matTooltip]="isStatusDisabled(status) ? 'Tilføj status' : 'Fjern status'"
          [class]="'chip chip--' + status.toLowerCase()"
          [class.chip--disabled]="isStatusDisabled(status)"
          (click)="toggleStatus(status)">
          @if (!isStatusDisabled(status)) {
            <mat-icon>checkmark</mat-icon>
          }
          @if (isStatusDisabled(status)) {
            <mat-icon>close</mat-icon>
          }
          {{ status | translateTerminalStatusEnum }}
        </span>
      }
    </div>
  </div>

  <form [formGroup]="formGroup">
    <div class="form-row">
      <mat-form-field class="mdc-textarea-fix">
        <mat-label>Note</mat-label>
        <textarea matInput formControlName="note" maxlength="2000"></textarea>
        <mat-hint align="end">{{ note.value.length || 0 }}/2000 karakterer</mat-hint>
        @if (note.hasError('required') || note.hasError('whitespace')) {
          <mat-error>
            <div>Skriv venligst note</div>
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-row align-right">
      <button type="button" mat-raised-button color="primary" (click)="save()" [disabled]="!isValid">Gem</button>
    </div>
  </form>

  <div class="terminal-status-logs">
    <h4>Terminalstatus log</h4>
    <table class="table">
      <thead>
        <tr>
          <th class="align-left">Status gemt</th>
          <th class="align-left">Tidspunkt</th>
          <th class="align-left">Note</th>
          <th class="align-left">Udført af</th>
        </tr>
      </thead>
      <tbody>
        @let terminalStatusLogs = terminalStatusLogs$ | async;

        @if ((terminalStatusLogs?.items?.length ?? 0) === 0) {
          <tr>
            <td colspan="5" class="text-center">
              <p>Der er ingen hændelser</p>
            </td>
          </tr>
        }
        @for (terminalStatusLog of terminalStatusLogs?.items; track terminalStatusLog) {
          <tr>
            <td>
              <div class="chip-list">
                @for (status of terminalStatusLog.statuses; track status) {
                  <span class="chip" [class]="'chip chip--' + status.toLowerCase()">
                    {{ status | translateTerminalStatusEnum }}
                  </span>
                }
              </div>
            </td>
            <td class="no-wrap">{{ terminalStatusLog.created | date: 'short' }}</td>
            <td>
              @if (terminalStatusLog.note) {
                <mat-icon svgIcon="note" class="cursor-help" [matTooltip]="terminalStatusLog.note" />
              }
            </td>
            <td>
              <span class="icon-with-text">
                {{ terminalStatusLog.createdBy }}
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>
    <mat-paginator
      #paginator
      [style.visibility]="statusLogCount ? 'visible' : 'hidden'"
      [pageIndex]="currentPage"
      [pageSize]="pagingOptions.pageSize"
      [length]="statusLogCount"
      [pageSizeOptions]="pagingOptions.pageSizeOptions"
      (page)="onPageChanged($event)"
      color="accent" />
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (paymentTerminal.serialNumber) {
    <div class="unit-identifier">
      <span>Terminal:</span>
      {{ paymentTerminal.serialNumber }}
    </div>
  }
  <button class="actions__button margin--right-2" mat-dialog-close type="button" mat-button>Luk</button>
</mat-dialog-actions>
